import React from 'react';
import {EditContentControls} from '../x7/content-parts/EditContentControls';
import {EditContentStore} from '../x7/content-parts/EditContentStore';
import {FlashcardsEdit} from './flashcard/crud/FlashcardsEdit';
import {GapFillingEditComponent} from './gap-filling/crud/GapFillingEditComponent';
import {GrexEdit} from './grouping-exercise/crud/GrexEdit';
import {X9MatchingQuestionEdit} from './matching-question/crud/X9MatchingQuestionEdit';
import {X9McqEdit} from './mcq/crud/X9McqEdit';
import {OpenEndedQuestionInlineEdit} from './open-ended-question-inline/crud/OpenEndedQuestionInlineEdit';
import {SelectQuestionEditComponent} from './select-question/crud/SelectQuestionEditComponent';
import {SlideShowEdit} from './slideshow/crud/SlideShowEdit';
import {X9StaticHtmlEdit} from './static-html/X9StaticHtmlEdit';
import {X9StaticImageEdit} from './static-image/X9StaticImageEdit';
import {X9SyncedAudioEdit} from './synced-audio/crud/X9SyncedAudioEdit';
import {X9SyncedVideoEdit} from './synced-video/crud/X9SyncedVideoEdit';

export class X9ContentEdit extends React.Component<{ store: EditContentStore }> {
  render() {
    const store = this.props.store;

    switch (store.content.ContentType) {
      case 'static-html':
        return (<>
          <X9StaticHtmlEdit store={store}/>
          <EditContentControls store={store}/>
        </>);
      case 'static-image':
        return (<>
          <X9StaticImageEdit store={store}/>
          <EditContentControls store={store}/>
        </>);
      case 'matching-question':
        return (<>
          <X9MatchingQuestionEdit store={store}/>
          <EditContentControls store={store}/>
        </>);
      case 'select-question':
        return (<>
          <SelectQuestionEditComponent store={store}/>
          <EditContentControls store={store}/>
        </>);
      case 'gap-filling':
        return (<>
          <GapFillingEditComponent store={store}/>
          <EditContentControls store={store}/>
        </>);
      case 'multiple-choice-question':
        return (<>
          <X9McqEdit store={store}/>
          <EditContentControls store={store}/>
        </>);
      case 'grouping-exercise':
        return (<>
          <GrexEdit store={store}/>
          <EditContentControls store={store}/>
        </>);
      case 'flashcards':
        return (<>
          <FlashcardsEdit store={store}/>
          <EditContentControls store={store}/>
        </>);
      case 'slideshow':
        return (<>
          <SlideShowEdit store={store}/>
          <EditContentControls store={store}/>
        </>);
      case 'open-ended-question':
        return null;
      case 'open-ended-question-inline':
        return (<>
          <OpenEndedQuestionInlineEdit store={store}/>
          <EditContentControls store={store}/>
        </>);
      case 'synced-audio':
        return (<>
          <X9SyncedAudioEdit store={store}/>
          <EditContentControls store={store}/>
        </>);
      case 'synced-video':
        return (<>
          <X9SyncedVideoEdit store={store}/>
          <EditContentControls store={store}/>
        </>);
    }

    return (
      <div className="row justify-content-center" key="unknown-content-type">
        <div className="col-auto">
          <div className="alert alert-danger">
            I don't know how to handle content type {store.content.ContentType}
          </div>
        </div>
      </div>);
  }

  componentDidMount() {
    const store = this.props.store;
    switch (store.content.ContentType) {
      case 'open-ended-question': {
        store.cancel();
      }
    }
  }
}
